import React from 'react'

export const getReactNodeSourceString = (
  value: React.ReactNode,
): string | undefined => {
  if (typeof value === 'string') {
    return value
  }

  if (
    React.isValidElement<{ source?: string }>(value) &&
    typeof value.props.source === 'string'
  ) {
    return value.props.source
  }

  return undefined
}
